<template>
	<section id="poptavka" class="inquiry">
		<div class="container">
			<h2 class="title-separator">Neváhejte nás oslovit s poptávkou</h2>

			<form @submit.prevent="submit" novalidate="novalidate" method="post" enctype="multipart/form-data"
				  v-show="!submitted">

				<inquiry-file-photo
						:maxFiles=maxFiles :count=form.files.length
						@sendFileToParent="handleChildFile($event)"
						@sendFileErrorToParent="handleChildFileError($event)"
						@sendDisabledBtnToParent="handleDisableSubmit($event)"
						@sendEnabledBtnToParent="handleEnableSubmit($event)"
						@fileUploading="eventLoading($event)">

				</inquiry-file-photo>

				<inquiry-input v-model="form.address"
							   name="address"
							   type="text"
							   required="true"
							   placeholder="Zadejte adresu nebo zaměřte svoji polohu"
							   maxlength="60"
							   @sendValueToParent="handleChildData($event)"
							   @updateError="handleError($event)"
							   :error="errors['address']"
							   :getLocation="true"
							   :location="form.location"
							   @clickLocation="getLocation($event)"></inquiry-input>

				<inquiry-input v-model="form.name"
							   name="name"
							   type="text"
							   required="true"
							   placeholder="Jméno a příjmení" maxlength="60"
							   v-on:updateError="handleError($event)"
							   v-on:sendValueToParent="handleChildData($event)"
							   :error="errors['name']">
				</inquiry-input>

				<inquiry-input v-model="form.email" name="email" type="text" required="true"
							   placeholder="Email"
							   maxlength="60"
							   v-on:updateError="handleError($event)"
							   v-on:sendValueToParent="handleChildData($event)"
							   :error="errors['email']"></inquiry-input>

				<inquiry-input v-model="form.telephone" name="telephone" type="tel" required="true"
							   placeholder="Telefon" maxlength="20"
							   v-on:updateError="handleError($event)"
							   v-on:sendValueToParent="handleChildData($event)"
							   :error="errors['telephone']"></inquiry-input>


				<inquiry-input v-model="form.message" name="message" type="textarea" required="false"
							   placeholder="Zpráva" maxlength="1000"
							   v-on:updateError="handleError($event)"
							   v-on:sendValueToParent="handleChildData($event)"
							   :error="errors['message']"></inquiry-input>

				<div class="form__upload" v-for="(file, index) in form.files">
					<div class="form__upload__img">
						<span>{{file.filename | getFormatFile }}</span>
						<img src="/dist/img/ico_file.svg" alt="Ikona souboru" width="40px">
					</div>

					<div class="form__upload__content">
						<span>{{file.filename}}</span>
						<span>{{humanSize(file.filesize)}}</span>
					</div>
					<button class="form__button-remove" @click.prevent="removeFile(file.index)">
						<img src="/dist/img/ico_bin.svg" alt="Ikona popelnice">
					</button>
				</div>

				<div class="form__upload-loader" v-show="loadingFile">
					Soubor se nahrává
				</div>

				<inquiry-file-input
						:maxFiles=maxFiles :count=form.files.length
						v-on:sendFileToParent="handleChildFile($event)"
						v-on:sendFileErrorToParent="handleChildFileError($event)"
						v-on:sendDisabledBtnToParent="handleDisableSubmit($event)"
						v-on:sendEnabledBtnToParent="handleEnableSubmit($event)"
						v-on:fileUploading="eventLoading($event)"
				></inquiry-file-input>

				<div class="mb-15" v-if="fileError">
					<p class="" v-if="fileError" v-html="fileError"></p>
				</div>

				<inquiry-input v-model="form.consent" name="consent"
							   label='Souhlas se zpracováním <a href="/dist/files/Axiom_Real_Informace_o_zpracovani_osobnich_udaju.pdf" target="_blank">osobních údajů</a>'
							   type="checkbox" required="true"
							   v-on:updateError="handleError($event)"
							   v-on:sendValueToParent="handleChildData($event)"
							   :error="errors['consent']"></inquiry-input>

				<vue-recaptcha class="mb-15"
							   ref="recaptcha"
							   @verify="onVerify"
							   @expired="onExpired"
							   :sitekey="sitekey">
				</vue-recaptcha>

				<p class="form__errors form__errors--recaptcha" v-if="form.recaptcha.error"
				   v-html="form.recaptcha.message"></p>

				<button type="submit" class="btn btn--red" :disabled="isSubmitDisabled">{{sendingMessage}}</button>
			</form>

			<p class="text-center" v-if="submitted">
				Děkujeme vám za vaši poptávku, budeme vás obratem kontaktovat.
			</p>

		</div>
	</section>
</template>

<script>
	import InquiryInput     from './Input.vue';
	import InquiryFileInput from './FileInput';
	import InquiryFilePhoto from './FileInputPhoto';
	import {Helper}         from '../../helper';

	import VueRecaptcha from 'vue-recaptcha';

	export default {
		name:       'inquiry-form',
		components: {
			InquiryInput,
			InquiryFileInput,
			VueRecaptcha,
			InquiryFilePhoto
		},
		data() {
			return {
				action:           'validateInquiryForm',
				sitekey:          '6LdkY5YUAAAAAKv3rODGzR-phITPKjpqgAk9BtcB',
				form:             {
					url:       window.location.host + window.location.pathname,
					address:   '',
					name:      '',
					email:     '',
					telephone: '',
					message:   '',
					location:  {
						lat: null,
						lng: null
					},
					files:     [],
					consent:   false,
					uniqueId:  '',
					recaptcha: {
						error:   false,
						token:   null,
						message: ''
					}
				},
				maxFiles:         3,
				errors:           {},
				fileError:        false,
				submitted:        false,
				isSubmitDisabled: false,
				loadingFile:      false,
				loading:          false
			};
		},
		methods:    {
			submit() {
				if(this.form.recaptcha.token !== null) {
					this.xhr = $.ajax({
						method:     'post',
						url:        document.environments.adminAjax,
						data:       {
							action: this.action,
							form:   this.form
						},
						dataType:   'json',
						beforeSend: this.aBefore,
						success:    this.aSuccess,
						error:      this.aError,
						complete:   this.aComplete
					});
				} else {
					this.form.recaptcha.error   = true;
					this.form.recaptcha.message = 'Pole "recaptcha" je povinné.';
				}
			},

			onVerify(response) {
				this.form.recaptcha.token   = response;
				this.form.recaptcha.error   = false;
				this.form.recaptcha.message = '';
			},
			onExpired() {
				this.form.recaptcha.token   = null;
				this.form.recaptcha.error   = true;
				this.form.recaptcha.message = 'Recaptcha Expired';
			},
			resetRecaptcha() {
				this.$refs.recaptcha.reset(); // Direct call reset method
			},
			aBefore() {
				this.errors  = [];
				this.loading = true;
			},
			aSuccess: function(response) {
				this.submitted  = true;
				window.location = '/dekujeme-za-vasi-poptavku';
			},
			aError:   function(xhr) {
				if(xhr.responseJSON) {
					this.errors = xhr.responseJSON.errors;
					this.scrollToErrors();
				} else {
					this.errors = [];
				}
			},
			scrollToErrors() {
				setTimeout(() => {
					if($('.' + 'form__errors').length) {
						let top = parseInt($('.' + 'form__errors')
							.offset().top);
						/* Animation */
						$('html, body')
							.animate({
								scrollTop: top
							}, 1200, function() {

							});
					}
				}, 10);
			},
			aComplete() {
				this.loading = false;
			},
			handleChildData(data) {
				this.form[data.field] = data.value;
			},
			handleError(data) {
				this.errors[data.field] = data.error;
			},
			handleChildFile(data) {
				this.fileError = false;
				this.form.files.push(data);
			},
			handleChildFileError(message) {
				this.fileError = message;
			},
			removeFile(index) {
				this.form.files.splice(index, 1);
			},
			humanSize(filesize) {
				return Helper.bytesToSize(filesize);
			},
			handleDisableSubmit() {
				this.isSubmitDisabled = true;
			},
			handleEnableSubmit() {
				this.isSubmitDisabled = false;
			},

			getLocation(event) {
				this.form.location.lat = '';
				this.form.location.lng = '';

				if(event) {
					this.form.location.lat = event.lat;
					this.form.location.lng = event.lng;
				}
			},

			eventLoading(event) {
				this.loadingFile = event;
			}
		},
		computed:   {
			sendingMessage() {
				return !this.loading ? 'Odeslat zprávu' : 'Odesíláme zprávu';
			}
		},

		filters: {
			getFormatFile(fileName) {
				return /[^.]+$/.exec(fileName)[0];
			}
		}
	};

</script>

<style scoped>

</style>
